module.exports = __webpack_public_path__ + "media/crypto/opaiglg-e5b6eeea.png";